<template>
  <div
    class="min-h-[100px] border border-gray-200 dark:border-gray-700 p-1 transition-colors"
    :class="{
      'bg-white dark:bg-gray-800': isCurrentMonth,
      'bg-gray-50 dark:bg-gray-900/50': !isCurrentMonth,
      'ring-2 ring-primary-500 ring-inset': isToday,
      'bg-primary-50 dark:bg-primary-900/20': dragOver
    }"
    @dragover.prevent="onDragOver"
    @dragenter.prevent="dragOver = true"
    @dragleave="dragOver = false"
    @drop="onDrop"
    @click="onDayClick">
    <div class="text-xs font-medium mb-1 px-0.5" :class="isToday ? 'text-primary-500' : (isCurrentMonth ? 'text-gray-700 dark:text-gray-300' : 'text-gray-400 dark:text-gray-600')">
      {{ dayNumber }}
    </div>
    <div class="space-y-0.5">
      <CalendarPostPill
        v-for="post in visiblePosts"
        :key="post.id"
        :post="post"
        :color="getColor(post)"
        @click="$emit('click-post', $event)" />
      <button
        v-if="posts.length > maxVisible"
        @click.stop="showAll = !showAll"
        class="text-[10px] text-gray-500 dark:text-gray-400 hover:text-primary-500 px-1">
        {{ showAll ? 'Show less' : `+${posts.length - maxVisible} more` }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { getDate } from 'date-fns'
import CalendarPostPill from './calendar_post_pill.vue'

const props = defineProps({
  date: { type: Date, required: true },
  posts: { type: Array, default: () => []},
  isCurrentMonth: { type: Boolean, default: true },
  isToday: { type: Boolean, default: false },
  campaignColors: { type: Map, default: () => new Map() }
})

const emit = defineEmits(['drop', 'click-post', 'click-day'])

const dragOver = ref(false)
const showAll = ref(false)
const maxVisible = 3

const dayNumber = computed(() => getDate(props.date))

const visiblePosts = computed(() => (showAll.value ? props.posts : props.posts.slice(0, maxVisible)))

function getColor(post) {
  return props.campaignColors.get(post.gbp_campaign_id) || { bg: 'bg-gray-100', text: 'text-gray-800', dot: 'bg-gray-500', darkBg: 'dark:bg-gray-700', darkText: 'dark:text-gray-200' }
}

function onDragOver(e) {
  e.dataTransfer.dropEffect = 'move'
  dragOver.value = true
}

function onDrop(e) {
  dragOver.value = false
  try {
    const data = JSON.parse(e.dataTransfer.getData('application/json'))
    emit('drop', data.postId, props.date)
  } catch (_) {
    // ignore invalid drag data
  }
}

function onDayClick() {
  emit('click-day', props.date)
}
</script>
